const initialState = {
  resultsExclusionsCategoriesList: [],
  resultsExclusionsCategory: {},
  resultsExclusionsCategoryAdd: {},
  resultsProductExclusionsCategoriesList: [],
  updateProductExclusionsCategory: {},
  resultsProductExclusionsDelete: {},
  resultsProductExclusionsCategoryAdd: {},
  loading: false
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "GET_LIST_EXCLUSIONS_CATEGORY":
    case "GET_PRODUCT_LIST_EXCLUSIONS_CATEGORY":
    case "GET_EXCLUSIONS_CATEGORY":
    case "CREATE_EXCLUSIONS_CATEGORY":
    case "CREATE_PRODUCT_EXCLUSIONS_CATEGORY":
    case "UPDATE_PRODUCT_EXCLUSIONS_CATEGORY":
    case "DELETE_PRODUCT_EXCLUSIONS_CATEGORY":
      newState.loading = true;
      break;
    case "LIST_EXCLUSIONS_CATEGORY_RESPONSE_GET":
      newState.resultsExclusionsCategoriesList = action.value;
      newState.loading = false;
      break;
    case "EXCLUSIONS_CATEGORY_RESPONSE_GET":
      newState.resultsExclusionsCategory = action.value;
      newState.loading = false;
      break;
    case "CREATE_EXCLUSIONS_CATEGORY_RESPONSE":
      newState.resultsExclusionsCategoryAdd = action.value;
      newState.loading = false;
      break;
    case "LIST_PRODUCT_EXCLUSIONS_CATEGORY_RESPONSE_GET":
      newState.resultsProductExclusionsCategoriesList = action.value;
      newState.loading = false;
      break;
    case "UPDATE_PRODUCT_EXCLUSIONS_CATEGORY_RESPONSE":
      newState.updateProductExclusionsCategory = action.value;
      newState.loading = false;
      break;
    case "DELETE_PRODUCT_EXCLUSIONS_CATEGORY_RESPONSE_GET":
      newState.resultsProductExclusionsDelete = action.value;
      newState.loading = false;
      break;
    case "CREATE_PRODUCT_EXCLUSION_CATEGORY_RESPONSE":
      newState.resultsProductExclusionsCategoryAdd = action.value;
      newState.loading = false;
      break;
    case "RESET_EXCLUSIONS_CATEGORY_RESPONSES":
      newState.resultsExclusionsCategoriesList = [];
      newState.resultsExclusionsCategory = {};
      newState.resultsExclusionsCategoryAdd = {};
      newState.resultsProductExclusionsCategoriesList = [];
      newState.updateProductExclusionsCategory = {};
      newState.resultsProductExclusionsDelete = {};
      newState.resultsProductExclusionsCategoryAdd = {};
      break;
    default:
      break;
  }
  return newState;
}

export default reducer;
